<template>
  <PersonalAreaTemplate
    :editing="editing"
    :max-width="modal ? null : 888"
    :files="checkData.image"
    :delete-files="checkData.deleteFiles"
    maxFiles="12"
    maxFilesShow="12"
    :on-save="onSave"
  >
    <v-form class="d-grid grid-col-sm-1-1 gap-5" ref="form" lazy-validation>
    <BaseInput
      :label="localStorage.translations.pages['setting-personal_area'].labels['pasport']"
      v-model="checkData.text"
      :placeholder="localStorage.translations.pages['setting-personal_area'].labels['pasport']"
      :rules="checkData.dateEnd || checkData.image.length ? ['required'] : null"
      :view="!editing"
    />
    <BaseInput
      type="date-picker"
      :label="
            localStorage.translations.pages['setting-personal_area'].labels['srok-deystiviya']
          "
      v-model="checkData.dateEnd"
      :min="new Date().toISOString().slice(0, 10)"
      placeholder="–"
      clearable
      :rules="checkData.text || checkData.image.length ? ['required'] : null"
      :view="!editing"
      :view-value="checkData.dateEnd ? $formatDate(checkData.dateEnd) : '-'"
    />
    </v-form>
  </PersonalAreaTemplate>
</template>

<script>
import { mapActions } from 'vuex'
import PersonalAreaTemplate from 'components/personalArea/personalAreaTemplate'

export default {
  name: 'Passport',
  props: {
    editing: Boolean,
    passport_data: Object,
    employeeId: Number,
    onSave: Function,
    modal: Boolean
  },
  components: {
    PersonalAreaTemplate,
  },
  data: () => ({
    checkData: {
      text: null,
      image: [],
      dateEnd: null,
      deleteFiles: [],
    },
    base64: [],
  }),
  watch: {
    passport_data() {
      this.onActualData()
    },
    'checkData.image'() {
      for (let i in this.checkData.image) {
        if (this.checkData.image[i] === null || '') {
          this.checkData.image.splice(i, 1)
        }
      }
    },
    checkData: {
      deep: true,
      handler() {
        if (this.editing) {
          this.onNavigationGuardianCheck({
            data: { passport: this.checkData },
            overwrite: false,
          })
        }
      },
    },
  },
  mounted() {
    this.onActualData()
  },
  methods: {
    ...mapActions('user', ['onUserUpdateEmployeeData']),
    ...mapActions('employee', ['onEmployeeUpdate']),
    ...mapActions('navigationGuardian', ['onNavigationGuardianCheck']),
    onActualData() {
      if (this.passport_data) {
        this.checkData.text = this.passport_data.text
        this.checkData.dateEnd = this.passport_data.date_end
        if (this.passport_data.image !== undefined) {
          this.checkData.image = this.passport_data.image
        }
      }
      this.onNavigationGuardianCheck({
        data: { passport: this.checkData },
        overwrite: true,
      })
    },
    async deleteImageBD() {
      if (this.checkData.deleteFiles.length) {
        for (let i in this.checkData.deleteFiles) {
          this.$store.dispatch('deleteFile', {
            url: this.checkData.deleteFiles[i],
          })
        }
        this.checkData.deleteFiles = []
      }
    },
    async submitFile(file, i) {
      return new Promise((resolve, reject) => {
        let formData = new FormData()
        formData.append('file', file)
        this.$store
          .dispatch('uploadFile', {
            data: formData,
            use_case: file.type === 'application/pdf' ? null : 'cover',
          })
          .then((response) => {
            this.checkData.image[i] = response.data.url
            return resolve(response)
          })
          .catch((err) => {
            this.checkData.image.splice(i, 1)
            return reject(err)
          })
      })
    },
    async saveChange() {
      return new Promise(async (resolve, reject) => {
        if (this.$checkNavigationGuardianChange('passport')) {
          await Promise.all(
            this.checkData.image.map(async (file, index) => {
              if (typeof file !== 'string') {
                await this.submitFile(file, index)
              }
            }),
          )
          await this.deleteImageBD()
          let data = {
            passport_data: JSON.stringify({
              text: this.checkData.text,
              image: this.checkData.image,
              date_end: this.checkData.dateEnd,
            }),
          }
          resolve(data)
        } else resolve(true)
      })
    },
  },
}
</script>
